import React, { useEffect } from 'react';
import './BlogsOfHome.css'
import { makeStyles } from '@material-ui/core/styles';
import AOS from 'aos';
import 'aos/dist/aos.css';

const BlogsOfHome = (props) => {

    const useStyles = makeStyles({
        root: {
            maxWidth: 345,
        },
        media: {
            height: 140,
        },
    });
    useEffect(() => {
        AOS.init({ duration: 1000 })
    })


    const { blogName, blogImg, blogAddress } = props.homeBlog;
    const classes = useStyles();

    return (
        <div className="col-md-4 col-sm-6 col-12 blogs-area" data-aos="fade-right">
            <div>
                <div class="card-deck">
                    <div class="card blog-content">
                        <img src={blogImg} class="card-img-top" alt="..." />
                        <div class="card-body">
                            <h5 class="card-title text-center"> {blogName} </h5>
                        </div>
                        <div class="card-footer">
                            <a class="blog-btn" href={blogAddress}
                                target="_blank">Read Blog</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BlogsOfHome;